<template>
    <div class="sound" @click="handleChangeVisible">
        <div
            v-show="visible"
            class="sound-control"
            @click.stop=""
            @mouseleave="handleChangeVisible"
        >
            <el-slider :value="value" vertical height="100px" @input="handleChange" />
        </div>
        <img class="sound-icon" :src="mute ? icons.mute : icons.sound" alt="音量" />
    </div>
</template>

<script>
import soundIcon from '@images/player/sound.svg';
import muteIcon from '@images/player/mute.svg';
const icons = {
    mute: muteIcon,
    sound: soundIcon
};
export default {
    name: 'Sound',
    props: {
        value: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            icons: Object.freeze(icons),
            visible: false,
            cacheValue: this.value
        };
    },
    computed: {
        mute() {
            return this.value === 0;
        }
    },
    methods: {
        handleChangeVisible() {
            this.visible = !this.visible;
        },
        handleChange(value) {
            this.$emit('change', value);
        }
    }
};
</script>

<style lang="scss" scoped>
.sound {
    position: relative;
    &-control {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        background: #303133;
        color: #fff;
        padding: 14px;
        border-radius: 8px;
        &::v-deep {
            .el-slider.is-vertical .el-slider__runway {
                margin: 0 !important;
            }
            .el-slider__button,
            .el-slider__button-wrapper {
                width: 10px;
                height: 10px;
            }
            .el-slider.is-vertical .el-slider__button-wrapper {
                left: -4px !important;
            }
        }
    }
}
</style>
